var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',_vm._l((_vm.originalColumns),function(column,key){return _c('div',{key:key},[_c('manage-column-field',{attrs:{"column":column,"inSelection":_vm.inSelection(column)},on:{"changeSelectedColumn":_vm.changeSelectedColumn}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }